export const CACHE_TIMEOUT_MS = 24 * 60 * 60 * 1000; // 24 hours

export const DEFAULT_STAT_POST_PROPS = {
  operator: 'UPD',
  time: -1,
};
